<template>
	<div class="prog_reg-body theme-light">
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-12 mb-4">
					<div class="pt-5 pb-5 disclaimer alert text-center theme-darkgray mb-2">
						<h2>Успешная регистрация</h2>
						<p>Спасибо! Ваша регистрация принята.</p>
						<p>
							С уважением,<br>
							Команда Школы управления СКОЛКОВО<br>
							info@skolkovo.ru<br>
							+7 495 539 30 03<br>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ManagerContact',
	props: [
		'formData',
	],
	data() {
		return {
		};
	},
	computed: {
	},
	mounted() {

	},
	methods: {
	},
};
</script>

<style scoped>

</style>
